module.exports = "<navbar></navbar>\r\n\r\n<router-outlet></router-outlet>\r\n\r\n\r\n<app-footer></app-footer>"